<template>

<app-panel-content :slim="true" :grow="true">

    <app-panel-title :text="item.name" :is-big="true" />
	
    <app-panel-summary v-if="$convention.setup.service.registration" label="Status" :tag="$constants.badge.statusName[item.status]" :status="$constants.badge.statusTheme[item.status]" :theme="$constants.badge.statusTheme[item.status]" />
		
	<app-panel-summary label="Ref." :value="item.reference" />
	
    <app-panel-metrics :count="2">

        <app-panel-metric label="Badges" :value="item.count.badges" />

        <app-panel-metric label="Items" :value="item.count.items" />

    </app-panel-metrics>
	
</app-panel-content>

</template>

<script>

export default {

    props: ['item']

}

</script>

<style scoped>

</style>
